import React from 'react';
import { Formik, Form } from 'formik';

import { createFormValidationFn } from 'client/helpers/formikHelpers';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrBox from 'client/components/SrBox';
import SrTextGreycliff from 'client/components/SrTextGreycliff';
import SrPartnerListingWithdrawModal from 'client/components/SrPartnerListingWithdrawCard/SrPartnerListingWithdrawModal';

const formFields = [
  {
    id: 'uninstallItems',
    type: 'yes_no',
    properties: {
      className: 'yesnoFullWidth',
    },
  },
];

const SrPartnerListingWithdrawRemoveItemsModal = ({ onClose, onSubmit }) => {
  return (
    <Formik
      validate={(formValues) => {
        return createFormValidationFn(formFields)(formValues);
      }}
      onSubmit={onSubmit}
      render={(formikBag) => {
        return (
          <SrPartnerListingWithdrawModal
            disabled={!formikBag.isValid}
            onClose={onClose}
            onConfirm={formikBag.handleSubmit}
          >
            <Form>
              <SrBox textAlign="center" margin="0 0 20px">
                <img
                  width="130px"
                  height="auto"
                  src="/images/install-marketing-items-car.svg"
                  alt="uninstall"
                />
                <SrBox height="16px" />
                <SrTextGreycliff weight="800" size="26" lineHeight="33px" display="block">
                  Does Sunroom need to remove items from the home?
                </SrTextGreycliff>
              </SrBox>
              <SrBox margin="0 0 40px">
                {formFields.map((formField) => (
                  <SrFormikField
                    key={formField.id}
                    formField={formField}
                    formikBag={formikBag}
                    theme={SR_FIELD_THEME_ADOBE}
                  />
                ))}
              </SrBox>
            </Form>
          </SrPartnerListingWithdrawModal>
        );
      }}
    />
  );
};

SrPartnerListingWithdrawRemoveItemsModal.displayName = 'SrPartnerListingWithdrawRemoveItemsModal';

export default SrPartnerListingWithdrawRemoveItemsModal;
